import { useQuery } from "@tanstack/react-query";
import { api } from "../../services/api/endpoints";

/**
 * The anonymous file — every upcoming fixture across every sport, Kev's own
 * read with no numbers, and a value indicator that names the market never the
 * side. PUBLIC: no `enabled` gate on a session, and no `RequireAuth` above
 * whatever renders it — this is the tier a stranger and a search crawler see,
 * kev-docs/kev-landing-and-seo-plan.md's whole reason to exist.
 *
 * ONE query key (`["fixtures-public"]`) for every caller, same reasoning
 * `useFreeFixtures` gives for its own cache key: the landing list is the only
 * caller today, but a page one level in that wanted the same rows (say, to
 * render the value chip beside a fixture it already knows the key of) reads
 * from the same cache rather than firing a second request for data already
 * sitting in memory.
 */
export function useFixturesPublic() {
  return useQuery({
    queryKey: ["fixtures-public"],
    queryFn: api.fixturesPublic,
    /* Same cadence as the account and Premium tiers this sits below — rebuilt
       by the pipeline every 10 minutes for fixtures inside 72 hours, not on
       every focus. */
    staleTime: 5 * 60_000,
    retry: false,
  });
}
